import './App.less';
import { RouteConfig } from '@/routes';
import { NavAnchorProvider } from '@/components';
import { useTranslation } from 'react-i18next';

declare global {
  interface Window {
    trans: Function;
  }
}
function App() {
  const { t } = useTranslation();
  window.trans = t;

  return (
    <NavAnchorProvider>
      <RouteConfig />
    </NavAnchorProvider>
  );
}

export default App;
